import React, { useContext } from 'react'
import { Grid, Button, Link, Box } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { recoverPassword } from '../api'
import { RecoverPasswordRequest } from '../model'
import { translate } from '../i18n'
import { ExternSurface } from '../components'
import { FeedbackContext } from '../feedback'
import { AnyInput, useValidatedForm } from '../anyform'

export default function RecoverPasswordForm() {
    const feedbackContext = useContext(FeedbackContext)
    const { register, bind, isValid, setPristine } =
        useValidatedForm<RecoverPasswordRequest>()

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        if (!isValid()) {
            return
        }

        feedbackContext.showBackdrop()

        const request = bind()
        recoverPassword(request)
            .then((response) => {
                if (response.content) {
                    feedbackContext.showSuccess(
                        translate('auth.recover.success', {
                            email: request.email,
                        }) as string
                    )
                    setPristine()
                } else {
                    feedbackContext.showError(
                        translate('auth.recover.error') as string
                    )
                }
            })
            .catch((error) => {
                feedbackContext.showError(error.message)
            })
            .finally(() => {
                feedbackContext.closeBackdrop()
            })
    }

    return (
        <ExternSurface
            title={translate('auth.recover.title') as string}
            showTitle
        >
            <form autoComplete="off" noValidate onSubmit={onSubmit}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <AnyInput
                            type="email"
                            name="email"
                            label={translate('users.email') as string}
                            required
                            hiddenLabel
                            register={register}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Box my={2}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                size="large"
                            >
                                {translate('buttons.recover')}
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs="auto">
                        <Link component={RouterLink} to="/signin">
                            <small>{translate('buttons.signin')}</small>
                        </Link>
                    </Grid>
                </Grid>
            </form>
        </ExternSurface>
    )
}
